












































import { AxiosInstance } from 'axios'

export default {
  data() {
    return {
      tokenInvalid: false,
      success: false
    }
  },
  mounted() {
    //prüfen, ob der Token gesetzt und gültig ist
    this.tokenInvalid = false
    this.success = false

    if (!('token' in this.$route.query)) {
      this.tokenInvalid = true
      return
    }
    let that = this
    const http: AxiosInstance = this.$store.getters.http
    let url = `/api/auth/users/confirmation?token=` + this.$route.query.token
    http
      .get(url)
      .then(response => {
        let data = response.data
        if (data.ok) {
          that.success = true
          that.tokenInvalid = false
        } else {
          that.success = false
          that.tokenInvalid = true
        }
      })
      .catch(e => {
        that.tokenInvalid = true
        that.success = false
      })
  },
}
